export default __webpack_public_path__ + "static/filtro3-ddf32965414ccdf8dea093f859c355d5.png";